import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import {List} from 'immutable';
import CopyToClipboard from 'react-copy-to-clipboard';
import Copy from 'components/icons/Copy';
import {connect} from 'react-redux';
import {Request, RequestsMixin, GET} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import KitFrame from 'components/KitFrame';
import {iconsAdded} from '../utils/kit';
import DocumentationMixin from '../mixins/DocumentationMixin';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
    kitMutations: state.kitMutations,
  };
};

const DocumentationIconsController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
    kitMutations: ImmutablePropTypes.map,
  },

  mixins: [DocumentationMixin, RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      copiedUnicodeChar: null,
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      publications: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'publications'],
      }),
    });

    this.setRequest({
      iconSettings: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'icon-settings'],
      }),
    });

    this.setRequest({
      workingSetIcons: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
      }),
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({token: this.props.kitToken}),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(p => p.status === 'finished'),
      iconSettings: rm.type(this.requests.iconSettings, 'icon-settings').get(),
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all(),
    };
  },

  handleIconCopied(unicodeChar) {
    this.setState({
      copiedUnicodeChar: unicodeChar,
    }, () => {
      setTimeout(() => {
        this.setState({copiedUnicodeChar: null});
      }, 2000);
    });
  },

  renderPrefixAlert() {
    return (
      <div className="alert alert-danger bg-body has-icon m-xs-b-0">
        <i className="ficon ficon-lg ficon-warning alert-icon"></i>
        <p className="m-xs-b-0">
          Heads up! You&apos;re using the same icon prefix (<code>fa-</code>) as <a href="http://fontawesome.io/" target="_blank">Font
          Awesome</a> uses. If you want to keep using both, you should either 1) change your kit&apos;s icon prefix
          (found in icon settings) to avoid any icon collisions, or add all of the Font Awesome icons you&apos;re
          using into your kit and remove the reference to Font Awesome.
        </p>
      </div>
    );
  },

  renderIconsInKit() {
    const {kit, iconSettings, workingSetIcons} = this.resources();
    const sortedWorkingSetIcons = workingSetIcons.sortBy(record => record.createdAt.unix()).reverse();
    const unpublishedIcons = iconsAdded(this.props.kitMutations, this.props.kitToken)
      .map((request) => request.getIn(['record', 'icon']));
    const iconElements = sortedWorkingSetIcons
      .filter((workingSetIcon) => {
        return !unpublishedIcons.includes(workingSetIcon.name);
      })
      .map((workingSetIcon, index) => {
        const unicodeChar = String.fromCodePoint(parseInt(workingSetIcon.unicodeChar, 16));
        const handleIconCopied = () => this.handleIconCopied(unicodeChar);
        let copiedAlert = null;

        if (this.state.copiedUnicodeChar === unicodeChar) {
          copiedAlert = (
            <div className="alert alert-success alert-copy-confirmation m-xs-b-0 text-xs-center block text-white br-a p-xs-x-sm p-xs-y-xs p-xs-t-md" role="alert">
              <p className="m-xs-b-0">Copied</p>
            </div>
          );
        }

        return (
          <li key={workingSetIcon.id} className="asset asset-icon">
            <div className="icon-preview m-xs-b-xs">
              <i className={`${workingSetIcon.prefix} ${workingSetIcon.prefix}-lg`}>{unicodeChar}</i>
            </div>
            <div className="icon-label text-base">
              <span className="text-gray-darker font-weight-semibold block m-xs-b-xs">{workingSetIcon.cssName}</span>
              {copiedAlert}
              <div className="icon-label-details block">
                <span className="text-muted m-xs-r-xs inline-block valign-middle">{workingSetIcon.unicodeChar}</span>
                <CopyToClipboard text={unicodeChar} onCopy={handleIconCopied}>
                  <button title="Copy to clipboard" className="btn btn-link link-dashed-none m-xs-x-0 m-xs-l-sm text-muted inline-block valign-middle">
                    <Copy height="12px" width="12px" />
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          </li>
        );
      });
    const kitFrameElement = (
      <KitFrame kitToken={kit.token}>
        <ul className="grid-assets grid-assets-xs-6">
          {iconElements}
        </ul>
      </KitFrame>
    );
    const noIconsElement = (
      <div className="well bg-primary bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center">
        <h2 className="text-2x">This Kit Doesn't Have Any Icons</h2>
        <p className="lead m-xs-b-0 text-muted">Hey. It looks like you don't have any icons currently in this kit. Its pretty easy to <Link to={`/kits/${kit.token}/icons/new`} className="text-white">add some</Link> or even <Link to={`/kits/${kit.token}/icons/upload`} className="text-white">upload your own</Link>.</p>
      </div>
    );

    return (
      <section id="kit-components-icons-inventory" className="kit-components-icons-inventory m-xs-b-xl">
        <h2 className="text-2x m-xs-b-0">Icons in this Kit</h2>
        <hr className="hr-lg m-xs-t-sm m-xs-b-md" />

        {(iconElements.isEmpty()) ? noIconsElement : kitFrameElement}

        {(iconSettings.cssPrefix === 'fa') ? this.renderPrefixAlert() : ''}
      </section>
    );
  },

  renderIconSizes(cssPrefix) {
    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">Larger Icons</h3>
        <p>
          To increase icon sizes relative to their container, add one of the <code>{cssPrefix}-lg</code> (33% increase),
          <code>{cssPrefix}-2x</code>, <code>{cssPrefix}-3x</code>, <code>{cssPrefix}-4x</code>, or <code>{cssPrefix}-5x</code>classes.
        </p>
        <div className="bg-body br-t p-xs-a-md">
          <h4 className="text-sm text-upper text-muted">Example</h4>
          <p>
            <i className="ficon ficon-search ficon-lg"></i> {cssPrefix}-lg
          </p>
          <p>
            <i className="ficon ficon-search ficon-2x"></i> {cssPrefix}-2x
          </p>
          <p>
            <i className="ficon ficon-search ficon-3x"></i> {cssPrefix}-3x
          </p>
          <p>
            <i className="ficon ficon-search ficon-4x"></i> {cssPrefix}-4x
          </p>
          <p>
            <i className="ficon ficon-search ficon-5x"></i> {cssPrefix}-5x
          </p>
        </div>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="html">
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-search {cssPrefix}-lg"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-lg
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-search {cssPrefix}-2x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-2x
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-search {cssPrefix}-3x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-3x
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-search {cssPrefix}-4x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-4x
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-search {cssPrefix}-5x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-5x
            </div>
          </code>
        </pre>
        <div className="alert alert-info bg-body has-icon m-xs-b-0">
          <i className="ficon ficon-info-circle ficon-lg alert-icon"></i> If your icons are getting chopped off on top and bottom, make sure you have sufficient line-height.
        </div>
      </article>
    );
  },

  renderIconFixedWidth(cssPrefix) {
    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">Fixed Width Icons</h3>
        <p>
          Use <code>{cssPrefix}-fw</code> to set icons at a fixed width. Great to use when different icon
          widths throw off alignment. Especially useful in things like nav lists &amp; list groups.
        </p>
        <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
          <p className="m-xs-b-0">
            This example contains icons which may not be in your kit
          </p>
        </div>
        <div className="bg-body br-t p-xs-a-md">
          <h4 className="text-sm text-upper text-muted">Example</h4>
          <div className="row">
            <div className="col-xs-4">
              <div className="list-group m-xs-b-0">
                <a className="list-group-item" href="#">
                  <i className="ficon ficon-home ficon-fw"></i>&nbsp; Home
                </a>
                <a className="list-group-item" href="#">
                  <i className="ficon ficon-book ficon-fw"></i>&nbsp; Library
                </a>
                <a className="list-group-item" href="#">
                  <i className="ficon ficon-pencil ficon-fw"></i>&nbsp; Applications
                </a>
                <a className="list-group-item" href="#">
                  <i className="ficon ficon-gear ficon-fw"></i>&nbsp; Settings
                </a>
              </div>
            </div>
          </div>
        </div>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="html">
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-home {cssPrefix}-fw"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> Home
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-book {cssPrefix}-fw"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> Library
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-pencil {cssPrefix}-fw"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> Applications
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-cog {cssPrefix}-fw"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> Settings
            </div>
          </code>
        </pre>
      </article>
    );
  },

  renderIconLists(cssPrefix) {
    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">List Icons</h3>
        <p>
          Use <code>{cssPrefix}-ul</code> and <code>{cssPrefix}-li</code> to easily replace
          default bullets in unordered lists.
        </p>
        <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
          <p className="m-xs-b-0">
            This example contains icons which may not be in your kit
          </p>
        </div>
        <div className="bg-body br-t p-xs-a-md">
          <h4 className="text-sm text-upper text-muted">Example</h4>
          <ul className="ficon-ul m-xs-b-0">
            <li>
              <i className="ficon-li ficon ficon-check-square"></i> List icons
            </li>
            <li>
              <i className="ficon-li ficon ficon-check-square"></i> can be used
            </li>
            <li>
              <i className="ficon-li ficon ficon-spinner ficon-spin"></i> as bullets
            </li>
            <li>
              <i className="ficon-li ficon ficon-square"></i> in lists
            </li>
          </ul>
        </div>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="html">
            <div>
              <span className="nt">&lt;ul</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-ul"</span>
              <span className="nt">&gt;</span>
            </div>
            <div>
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;li&gt;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-li {cssPrefix} {cssPrefix}-check-square"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>List icons
              <span className="nt">&lt;/li&gt;</span>
            </div>
            <div>
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;li&gt;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-li {cssPrefix} {cssPrefix}-check-square"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>can be used
              <span className="nt">&lt;/li&gt;</span>
            </div>
            <div>
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;li&gt;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-li {cssPrefix} {cssPrefix}-spinner {cssPrefix}-spin"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>as bullets
              <span className="nt">&lt;/li&gt;</span>
            </div>
            <div>
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;li&gt;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-li {cssPrefix} {cssPrefix}-square"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>in lists
              <span className="nt">&lt;/li&gt;</span>
            </div>
            <div>
              <span className="nt">&lt;/ul&gt;</span>
            </div>
          </code>
        </pre>
      </article>
    );
  },

  renderIconBordered(cssPrefix) {
    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">Bordered &amp; Pulled Icons</h3>
        <p>
          Use <code>{cssPrefix}-border</code> and <code>pull-right</code> or <code>pull-left</code>
          for easy pull quotes or article icons.
        </p>
        <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
          <p className="m-xs-b-0">
            This example contains icons which may not be in your kit
          </p>
        </div>
        <div className="bg-body br-t p-xs-a-md">
          <h4 className="text-sm text-upper text-muted">Example</h4>
          <i className="ficon ficon-quote-left ficon-3x pull-left ficon-border"></i> Gatsby believed in the green
            light, the orgastic future that year by year recedes before us. It eluded us then, but that’s no
            matter—tomorrow we will run faster, stretch out our arms farther… And then one fine morning— So we beat
            on, boats against the current, borne back ceaselessly into the past.
        </div>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="html">
            <span className="nt">&lt;i</span>
            <span className="na"> class=</span>
            <span className="s">"{cssPrefix} {cssPrefix}-quote-left {cssPrefix}-3x pull-left {cssPrefix}-border"</span>
            <span className="nt">&gt;&lt;/i&gt;</span>Gatsby believed in the green light...
          </code>
        </pre>
      </article>
    );
  },

  renderIconAnimated(cssPrefix) {
    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">Animated Icons</h3>
        <p>
          Use the <code>{cssPrefix}-spin</code> class to get any icon to rotate. Works well
          with <code>{cssPrefix}-spinner</code>, <code>{cssPrefix}-refresh</code>, and <code>{cssPrefix}-cog</code>.
        </p>
        <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
          <p className="m-xs-b-0">
            This example contains icons which may not be in your kit
          </p>
        </div>
        <div className="bg-body br-t p-xs-a-md">
          <h4 className="text-sm text-upper text-muted">Example</h4>
          <button className="btn btn-secondary btn-lg">
            <i className="ficon ficon-spinner ficon-spin"></i>
          </button>
          <button className="btn btn-secondary btn-lg">
            <i className="ficon ficon-sync ficon-spin"></i>
          </button>
          <button className="btn btn-secondary btn-lg">
            <i className="ficon ficon-gear ficon-spin"></i>
          </button>
        </div>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="html">
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-spinner {cssPrefix}-spin"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-refresh {cssPrefix}-spin"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-cog {cssPrefix}-spin"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
            </div>
          </code>
        </pre>
        <div className="alert alert-warning bg-body has-icon">
          <i className="ficon ficon-warning ficon-lg alert-icon"></i> Just a heads up. CSS3 animations aren't supported in IE8 - IE9.
        </div>
      </article>
    );
  },

  renderIconRotated(cssPrefix) {
    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">Rotated &amp; Flipped</h3>
        <p>
          To arbitrarily rotate and flip icons, use the <code>{cssPrefix}-rotate-*</code>
          and <code>{cssPrefix}-flip-*</code> classes.
        </p>
        <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
          <p className="m-xs-b-0">
            This example contains icons which may not be in your kit
          </p>
        </div>
        <div className="bg-body br-t p-xs-a-md">
          <h4 className="text-sm text-upper text-muted">Example</h4>
          <div>
            <i className="ficon ficon-flag"></i>&nbsp; normal<br />
            <i className="ficon ficon-flag ficon-rotate-90"></i>&nbsp;fa-rotate-90<br />
            <i className="ficon ficon-flag ficon-rotate-180"></i>&nbsp;fa-rotate-180<br />
            <i className="ficon ficon-flag ficon-rotate-270"></i>&nbsp;fa-rotate-270<br />
            <i className="ficon ficon-flag ficon-flip-horizontal"></i>&nbsp;fa-flip-horizontal<br />
            <i className="ficon ficon-flag ficon-flip-vertical"></i>&nbsp;fa-flip-vertical
          </div>
        </div>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="html">
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-flag"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> normal
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-flag {cssPrefix}-rotate-90"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-rotate-90
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-flag {cssPrefix}-rotate-180"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-rotate-180
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-flag {cssPrefix}-rotate-270"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-rotate-270
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-flag {cssPrefix}-flip-horizontal"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-flip-horizontal
            </div>
            <div>
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-flag {cssPrefix}-flip-vertical"</span>
              <span className="nt">&gt;&lt;/i&gt;</span> {cssPrefix}-flip-vertical
            </div>
          </code>
        </pre>
      </article>
    );
  },

  renderIconStacked(cssPrefix) {
    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">Stacked Icons</h3>
        <p>
          To stack multiple icons, use the <code>{cssPrefix}-stack</code> class on the parent,
          the <code>{cssPrefix}-stack-1x</code> for the regularly sized icon, and <code>{cssPrefix}-stack-2x</code>
          for the larger icon. <code>{cssPrefix}-inverse</code> can be used as an alternative icon color. You can
          even throw larger icon classes on the parent to get further control of sizing.
        </p>
        <div className="well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0" role="alert">
          <p className="m-xs-b-0">
            This example contains icons which may not be in your kit
          </p>
        </div>
        <div className="bg-body br-t p-xs-a-md">
          <h4 className="text-sm text-upper text-muted">Example</h4>
          <span className="ficon-stack ficon-lg">
            <i className="ficon ficon-square-o ficon-stack-2x"></i>
            <i className="ficon ficon-twitter ficon-stack-1x"></i>
          </span>
          {cssPrefix}-twitter on {cssPrefix}-square-o
          <br />
          <span className="ficon-stack ficon-lg">
            <i className="ficon ficon-circle ficon-stack-2x"></i>
            <i className="ficon ficon-flag ficon-stack-1x ficon-inverse"></i>
          </span>
          {cssPrefix}-flag on {cssPrefix}-circle
          <br />
          <span className="ficon-stack ficon-lg">
            <i className="ficon ficon-square ficon-stack-2x"></i>
            <i className="ficon ficon-code ficon-stack-1x ficon-inverse"></i>
          </span>
          {cssPrefix}-code on {cssPrefix}-square
          <br />
          <span className="ficon-stack ficon-lg">
            <i className="ficon ficon-camera ficon-stack-1x"></i>
            <i className="ficon ficon-ban ficon-stack-2x text-danger"></i>
          </span>
          {cssPrefix}-ban on {cssPrefix}-camera
        </div>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="html">
            <div className="p-xs-b-md-sm">
              <span className="nt">&lt;span</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-stack {cssPrefix}-lg"</span>
              <span className="nt">&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-square-o {cssPrefix}-stack-2x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-twitter {cssPrefix}-stack-1x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&lt;/span&gt;</span> {cssPrefix}-twitter on {cssPrefix}-square-o
              <span className="nt"></span>
            </div>
            <div className="p-xs-b-md-sm">
              <span className="nt">&lt;span</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-stack {cssPrefix}-lg"</span>
              <span className="nt">&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-circle {cssPrefix}-stack-2x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-flag {cssPrefix}-stack-1x {cssPrefix}-inverse"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&lt;/span&gt;</span> {cssPrefix}-flag on {cssPrefix}-circle
              <span className="nt">&lt;br&gt;</span>
            </div>
            <div className="p-xs-b-md-sm">
              <span className="nt">&lt;span</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-stack {cssPrefix}-lg"</span>
              <span className="nt">&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-square {cssPrefix}-stack-2x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-code {cssPrefix}-stack-1x {cssPrefix}-inverse"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&lt;/span&gt;</span> {cssPrefix}-code on {cssPrefix}-square
              <span className="nt">&lt;br&gt;</span>
            </div>
            <div className="p-xs-b-md-sm">
              <span className="nt">&lt;span</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix}-stack {cssPrefix}-lg"</span>
              <span className="nt">&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-camera {cssPrefix}-stack-1x"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&nbsp;&nbsp;&nbsp;&lt;i</span>
              <span className="na"> class=</span>
              <span className="s">"{cssPrefix} {cssPrefix}-ban {cssPrefix}-stack-2x text-danger"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
              <br />
              <span className="nt">&lt;/span&gt;</span> {cssPrefix}-ban on {cssPrefix}-camera
            </div>
          </code>
        </pre>
      </article>

    );
  },

  renderIconManual() {
    const {kit} = this.resources();

    return (
      <article className="example m-xs-b-xl">
        <h3 className="text-lg">Using CSS Only</h3>
        <p>
          You can render icons purely using CSS (rather than through dedicated HTML elements).
        </p>
        <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
          <code className="css">
            .icon-selector {'{'}<br />
            &nbsp;&nbsp;font-family: '{kit.subsetName}';<br />
            &nbsp;&nbsp;display: inline-block;<br />
            &nbsp;&nbsp;font-size: inherit;<br />
            &nbsp;&nbsp;font-weight: normal;<br />
            &nbsp;&nbsp;font-style: normal;<br />
            &nbsp;&nbsp;line-height: 1;<br />
            &nbsp;&nbsp;text-rendering: auto;<br />
            {'}'}<br />
            <br />
            .icon-selector:before {'{'}<br />
            &nbsp;&nbsp;content: '\f001'; /* your icon's unicode here */<br />
            {'}'}
          </code>
        </pre>
      </article>
    );
  },

  renderUsingIconsOnWeb() {
    const {iconSettings} = this.resources();
    const cssPrefix = iconSettings.cssPrefix;

    return (
      <section className="kit-components-icons-use m-xs-b-xl" id="kit-components-icons-use-web">
        <h2 className="text-2x m-xs-b-0">Using your icons on the web</h2>
        <hr className="hr-lg m-xs-y-sm" />
        <article className="example m-xs-b-xl">
          <p>
            You can place your Fort Awesome icons just about anywhere using your CSS kit prefix
            <code>{iconSettings.cssPrefix}</code> and the icon's name. Fort Awesome icons are designed to be used with inline
            elements (we like the <code>&lt;i&gt;</code> tag, but you can use <code>&lt;span&gt;</code> too).
          </p>
          <div className="bg-body br-t p-xs-a-md">
            <h4 className="text-sm text-upper text-muted">Example</h4>
            <i className="icon-2339 fa fa-search"></i>
          </div>
          <pre className="bg-gray-dark inset-darkest br-b p-xs-a-md">
            <code className="html">
              <span className="nt">&lt;i</span>
              <span className="na"> class=</span><span className="s">"{iconSettings.cssPrefix} {iconSettings.cssPrefix}-search"</span>
              <span className="nt">&gt;&lt;/i&gt;</span>
            </code>
          </pre>
          <div className="alert alert-info bg-body has-icon m-xs-b-0">
            <i className="ficon ficon-lg ficon-info-circle alert-icon"></i>
            <p className="m-xs-b-0">
              If you change the font-size of the icon's container, the icon gets bigger. Same things goes for color,
              drop shadow, and anything else you can imagine with CSS.
            </p>
          </div>
        </article>
        {(iconSettings.largerIconSizes) ? this.renderIconSizes(cssPrefix) : ''}
        {(iconSettings.fixedWidthIcons) ? this.renderIconFixedWidth(cssPrefix) : ''}
        {(iconSettings.listIcons) ? this.renderIconLists(cssPrefix) : ''}
        {(iconSettings.borderedPulledIcons) ? this.renderIconBordered(cssPrefix) : ''}
        {(iconSettings.spinningIcons) ? this.renderIconAnimated(cssPrefix) : ''}
        {(iconSettings.rotatedFlippedIcons) ? this.renderIconRotated(cssPrefix) : ''}
        {(iconSettings.stackedIcons) ? this.renderIconStacked(cssPrefix) : ''}
        {this.renderIconManual()}
      </section>
    );
  },

  renderUsingIconsOnDesktop() {
    return (
      <section className="kit-components-icons-use m-xs-b-xl" id="kit-components-icons-use-desktop">
        <h2 className="text-2x m-xs-b-0">Using your icons on the desktop</h2>
        <hr className="hr-lg m-xs-y-sm" />
        <p>
          Looking to use your kit's icons in design-based desktop apps? You can them both as a icon-font (a la how
          you would use Font Awesome's cheatsheet) or leverage the raw SVG versions of each.
        </p>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h3 className="m-xs-t-0 m-xs-b-xs text-base">Publish Your Kit</h3>
            <p>
              When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit's
              documentation. If you've made a change you want to use, <strong className="font-weight-semibold">make
              sure you publish</strong>.
            </p>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h3 className="m-xs-t-0 m-xs-b-xs text-base">Download Your Kit</h3>
            <p>
              After your kit has been published, you'll want to <strong className="font-weight-semibold">download a
              fresh copy of your kit's contents</strong> locally.
            </p>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h3 className="m-xs-t-0 m-xs-b-xs text-base">Use Icon Fonts or SVGs</h3>
            <p>
              Find the <code>*.otf</code> files in your downloaded kit, set it as the font in your current desktop
              application, and copy and paste the icons (not the unicode) directly from your kit's documentation into
              your designs. Conversely, you can also open any of the individual <code>*.svg</code> files for deeper
              manipulation.
            </p>
          </div>
        </div>
      </section>
    );
  },

  renderTroubleshootingIcons() {
    const {iconSettings} = this.resources();

    return (
      <section className="kit-components-icons-troubleshooting" id="kit-components-icons-troubleshooting">
        <h2 className="text-2x m-xs-b-0">Troubleshooting Icons</h2>
        <hr className="hr-lg m-xs-y-sm" />
        <article className="typefaces-weights m-xs-b-lg" id="typefaces-weights">
          <h3 className="text-lg">My kit's icons aren't showing up on my pages</h3>
          <p>
            If your icons aren't rendering properly, you'll want to check the following:
          </p>
          <ul>
            <li>Did you published all changes/updates to you kit?</li>
            <li>Did you either reference your kit's embed code or the path to downloaded assets in your pages' <code>&lt;head&gt;</code>?</li>
            <li>Did you reference the correct icon name? Check for typos (we know by experience)!</li>
            <li>Are you using any other Icon Font libraries with the same kit prefix (<code>{iconSettings.cssPrefix}-</code>) as your kit?</li>
          </ul>
        </article>
      </section>
    );
  },

  renderUnpublishedChangesAlert() {
    let retval = null;

    const {kitMutations} = this.props;
    const {kit} = this.resources();
    const iconsHaveBeenAdded = !iconsAdded(kitMutations, kit.token).isEmpty();

    if (iconsHaveBeenAdded) {
      retval = (
        <div className="alert alert-primary bg-body has-icon m-xs-b-xl">
          <i className="ficon ficon-lg ficon-warning alert-icon"></i>
          <p className="m-xs-b-0">Hmm, you&apos;ve added some icons that you haven&apos;t published yet. <strong>Publish to see them here</strong> and to use them in your project.</p>
        </div>
      );
    }

    return retval;
  },

  renderMain() {
    const {kit, finishedPublications} = this.resources();

    return (
      <div className="row">
        <div className="col-xs-3 col-xs-push-9 p-xs-l-xl">
          {this.renderNavigation(kit, {hasBeenPublished: !finishedPublications.isEmpty()})}
        </div>
        <div className="col-xs-9 col-xs-pull-3">
          {this.renderUnpublishedChangesAlert()}
          {this.renderIconsInKit()}
          {this.renderUsingIconsOnWeb()}
          {this.renderUsingIconsOnDesktop()}
          {this.renderTroubleshootingIcons()}
        </div>
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-documentation-icons m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true} render={this.renderSpinner} />
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(DocumentationIconsController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/DocumentationIconsController.js